import { render, staticRenderFns } from "./MillageAdd.vue?vue&type=template&id=30dfb488&"
import script from "./MillageAdd.vue?vue&type=script&lang=js&"
export * from "./MillageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports